import Immutable from 'immutable';
import * as Industries from './Industry';
import * as CompanySizes from './CompanySize'; // Display

/** @deprecated use marketplace-ui-reviews */

export const MINIMUM_REVIEWS_FOR_DISPLAY = 3; // Filter options

/** @deprecated use marketplace-ui-reviews */

export const ALL = 'ALL';
/** @deprecated use marketplace-ui-reviews */

export const FIVE_STARS = 'FIVE_STARS';
/** @deprecated use marketplace-ui-reviews */

export const FOUR_STARS = 'FOUR_STARS';
/** @deprecated use marketplace-ui-reviews */

export const THREE_STARS = 'THREE_STARS';
/** @deprecated use marketplace-ui-reviews */

export const TWO_STARS = 'TWO_STARS';
/** @deprecated use marketplace-ui-reviews */

export const ONE_STAR = 'ONE_STAR'; // Sort options

/** @deprecated use marketplace-ui-reviews */

export const NEWEST = 'NEWEST';
/** @deprecated use marketplace-ui-reviews */

export const OLDEST = 'OLDEST';
/** @deprecated use marketplace-ui-reviews */

export const HIGHEST = 'HIGHEST_OVERALL_RATING';
/** @deprecated use marketplace-ui-reviews */

export const LOWEST = 'LOWEST_OVERALL_RATING';
/** @deprecated use marketplace-ui-reviews */

export const MOST_HELPFUL = 'MOST_HELPFUL'; // Pagination

/** @deprecated use marketplace-ui-reviews */

export const REVIEWS_PER_PAGE = 10; // Text keys for local state

/** @deprecated use marketplace-ui-reviews */

export const FILTER_KEY = 'FILTER'; // overall rating filter

/** @deprecated use marketplace-ui-reviews */

export const INDUSTRY_KEY = 'INDUSTRY'; // industry filter

/** @deprecated use marketplace-ui-reviews */

export const EMPLOYEES_KEY = 'EMPLOYEES'; // company size filter

/** @deprecated use marketplace-ui-reviews */

export const SORT_KEY = 'SORT';
/** @deprecated use marketplace-ui-reviews */

export const PAGE_KEY = 'PAGE';
/** @deprecated use marketplace-ui-reviews */

export const SEARCH_KEY = 'SEARCH';
/** @deprecated use marketplace-ui-reviews */

export const FILTER = {
  ALL,
  FIVE_STARS,
  FOUR_STARS,
  THREE_STARS,
  TWO_STARS,
  ONE_STAR
};
/** @deprecated use marketplace-ui-reviews */

export const INDUSTRY = Industries;
/** @deprecated use marketplace-ui-reviews */

export const EMPLOYEES = CompanySizes;
/** @deprecated use marketplace-ui-reviews */

export const SORT = {
  NEWEST,
  OLDEST,
  HIGHEST,
  LOWEST,
  MOST_HELPFUL
};
/** @deprecated use marketplace-ui-reviews */

export const STATE_TO_QUERY = {
  // FILTER
  ALL: {},
  FIVE_STARS: {
    overallRating: 5
  },
  FOUR_STARS: {
    overallRating: 4
  },
  THREE_STARS: {
    overallRating: 3
  },
  TWO_STARS: {
    overallRating: 2
  },
  ONE_STAR: {
    overallRating: 1
  },
  // SORT
  NEWEST: {
    sortFields: [NEWEST]
  },
  OLDEST: {
    sortFields: [OLDEST]
  },
  HIGHEST: {
    sortFields: [HIGHEST]
  },
  LOWEST: {
    sortFields: [LOWEST]
  },
  MOST_HELPFUL: {
    sortFields: [MOST_HELPFUL]
  }
};
/** @deprecated use marketplace-ui-reviews */

export const STAR_NUM_TO_STATE = Immutable.Map({
  1: FILTER.ONE_STAR,
  2: FILTER.TWO_STARS,
  3: FILTER.THREE_STARS,
  4: FILTER.FOUR_STARS,
  5: FILTER.FIVE_STARS
});
/** @deprecated use marketplace-ui-reviews */

export const MINIMUM_SEARCH_LENGTH = 3;